import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "./assets/css/style.css";
import Vue from "vue";
import Vuex from "vuex";
import BootstrapVue from "bootstrap-vue";
import VueCookies from "vue-cookies";
import * as VueGoogleMaps from "vue2-google-maps";
import * as modals from "@/lib/modals";
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText
} from "@fortawesome/vue-fontawesome";
import Multiselect from "vue-multiselect";
import axios from "axios";
import permissions from "@/security/permissions";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import "./font-library";
import OrderNavbar from "@/components/OrderNavbar.vue";
import InputField from "@/components/widgets/InputField.vue";
import ContactAddress from "@/components/widgets/Address.vue";
import DateRangeField from "@/components/widgets/DateRange.vue";
import ContextMenuButton from "@/components/widgets/ContextMenuButton.vue";
import DateField from "@/components/widgets/DateField.vue";
import DeliveryForSelect from "@/components/form/DeliveryForSelect.vue";
import FacilitySelect from "@/components/form/FacilitySelect.vue";
import AgentFacilitySelect from "@/components/form/AgentFacilitySelect.vue";
import ManufacturerSelect from "@/components/form/ManufacturerSelect.vue";
import AgentManufacturerSelect from "@/components/form/AgentManufacturerSelect.vue";
import ChargeTypeSelect from "@/components/form/ChargeTypeSelect.vue";
import ReferenceTypeSelect from "@/components/form/ReferenceTypeSelect.vue";
import OrderTypeSelect from "@/components/form/OrderTypeSelect.vue";
import ReferenceTypeEditor from "@/components/form/ReferenceTypeEditor.vue";
import DeliveryTypeSelect from "@/components/form/DeliveryTypeSelect.vue";
import CarrierSelect from "@/components/form/CarrierSelect.vue";
import BillToSelect from "@/components/form/BillToSelect.vue";
import AgentBillToSelect from "@/components/form/AgentBillToSelect.vue";
import CommoditySelect from "@/components/form/CommoditySelect.vue";
import AgentCommoditySelect from "@/components/form/AgentCommoditySelect.vue";
import OrderStatusSelect from "@/components/form/OrderStatusSelect.vue";
import SearchOrderFilterSelect from "@/components/form/SearchOrderFilterSelect.vue";
import TruckTemplateWeekdaysSelect from "@/components/form/TruckTemplateWeekdaysSelect.vue";
import TruckStatusSelect from "@/components/form/TruckStatusSelect.vue";
import MultiInputField from "@/components/widgets/MultiInputField.vue";
import OrderParty from "@/components/order/OrderParty.vue";
import StateSelect from "@/components/form/StateSelect.vue";
import UnitOfMeasureSelect from "@/components/form/UnitOfMeasureSelect.vue";
import ValidationErrors from "@/components/widgets/ValidationErrors.vue";
import Btn from "@/components/form/Button.vue";
import SaveIndicatorDialog from "@/components/widgets/SaveIndicatorDialog.vue";
import OrdersTable from "@/components/order/OrdersTable.vue";
import OrderBySelect from "@/components/form/OrderBySelect.vue";
import BarcodeCompanySelect from "@/components/form/BarcodeCompanySelect.vue"
import BarcodeBillToSelect from "@/components/form/BarcodeBillToSelect.vue"
import BarcodeManufacturerSelect from "@/components/form/BarcodeManufacturerSelect.vue"
import ItemTypeSelect from  "@/components/form/ItemTypeSelect.vue"
import InventoryItemStatusSelect from "@/components/form/InventoryItemStatusSelect.vue"
import BarcodeOrderStatusSelect from "@/components/form/BarcodeOrderStatusSelect.vue"
import DamageCodeSelect from "@/components/form/DamageCodeSelect.vue"
import ReturnReasonSelect from "@/components/form/ReturnReasonSelect.vue"
import StockOrderStatusSelect from "@/components/form/StockOrderStatusSelect.vue"
import StockOrderItemStatusSelect from "@/components/form/StockOrderItemStatusSelect.vue"
import BarcodeOrderItemStatusSelect from "@/components/form/BarcodeOrderItemStatusSelect.vue"
import WarehouseLocationSelect from "@/components/form/WarehouseLocationSelect.vue"
import WarehouseLocationCategorySelect from "@/components/form/WarehouseLocationCategorySelect.vue"
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { isMobile } from "mobile-device-detect";
import vSelect from "vue-select";
import Input from "@/components/form/Input.vue";
import vTime from "@/components/form/Time.vue";
import vDate from "@/components/form/DateInput.vue";
import DateRange from "@/components/form/DateRange.vue";
import MultiInput from "@/components/form/MultiInput.vue";
import AlertTypeSelect from "@/components/form/AlertTypeSelect.vue";
import "vue-select/dist/vue-select.css";
import "./validation";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import moment from "moment";
import numbro from "numbro";
import "@/lib/validationRules";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import VueMask from "v-mask";


Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);
Vue.component("Input", Input);
Vue.component("DateInput", vDate);
Vue.component("DateRange", DateRange);
Vue.component("Time", vTime);
Vue.component("MultiInput", MultiInput);
Vue.component("context-menu-button", ContextMenuButton);
Vue.component("v-select", vSelect);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);
Vue.component("shortcut-bar", OrderNavbar);
Vue.component("input-field", InputField);
Vue.component("contact-address", ContactAddress);
Vue.component("date-field", DateField);
Vue.component("date-range-field", DateRangeField);
Vue.component("multiselect", Multiselect);
Vue.component("facility-select", FacilitySelect);
Vue.component("agent-facility-select", AgentFacilitySelect);
Vue.component("delivery-for-select", DeliveryForSelect);
Vue.component("search-order-filter-select", SearchOrderFilterSelect);
Vue.component("manufacturer-select", ManufacturerSelect);
Vue.component("agent-manufacturer-select", AgentManufacturerSelect);
Vue.component("reference-type-select", ReferenceTypeSelect);
Vue.component("commodity-select", CommoditySelect);
Vue.component("agent-commodity-select", AgentCommoditySelect);
Vue.component("order-type-select", OrderTypeSelect);
Vue.component("delivery-type-select", DeliveryTypeSelect);
Vue.component("reference-type-editor", ReferenceTypeEditor);
Vue.component("multi-input-field", MultiInputField);
Vue.component("order-party", OrderParty);
Vue.component("state-select", StateSelect);
Vue.component("bill-to-select", BillToSelect);
Vue.component("agent-bill-to-select", AgentBillToSelect);
Vue.component("order-status-select", OrderStatusSelect);
Vue.component("truck-template-weekdays-select", TruckTemplateWeekdaysSelect);
Vue.component("truck-status-select", TruckStatusSelect);
Vue.component("btn", Btn);
Vue.component("save-indicator-dialog", SaveIndicatorDialog);
Vue.component("unit-of-measure-select", UnitOfMeasureSelect);
Vue.component("charge-type-select", ChargeTypeSelect);
Vue.component("orders-table", OrdersTable);
Vue.component("alert-type-select", AlertTypeSelect);
Vue.component("carrier-select", CarrierSelect);
Vue.component("order-by-select", OrderBySelect);
Vue.component("barcode-company-select", BarcodeCompanySelect);
Vue.component("barcode-bill-to-select", BarcodeBillToSelect);
Vue.component("barcode-manufacturer-select", BarcodeManufacturerSelect);
Vue.component("item-type-select", ItemTypeSelect);
Vue.component("warehouse-location-select", WarehouseLocationSelect);
Vue.component("inventory-item-status-select", InventoryItemStatusSelect);
Vue.component("barcode-order-status-select", BarcodeOrderStatusSelect);
Vue.component("damage-code-select", DamageCodeSelect);
Vue.component("return-reason-select", ReturnReasonSelect);
Vue.component("barcode-order-item-status-select", BarcodeOrderItemStatusSelect);
Vue.component("stock-order-status-select", StockOrderStatusSelect);
Vue.component("stock-order-item-status-select", StockOrderItemStatusSelect);
Vue.component("warehouse-location-category-select", WarehouseLocationCategorySelect);

import Fragment from "vue-fragment";
import { getModule } from "vuex-module-decorators";
import { AccountModule } from "@/store/modules";
import VueFormWizard from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { permissionExists } from "./utils";
Vue.use(VueFormWizard);
Vue.use(Fragment.Plugin);
Vue.use(BootstrapVue);
Vue.use(VueMask);
Vue.use(VueCookies, { expires: "7d" });
Vue.use(Vuex);
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
    libraries: "places"
  },
  installComponents: true
});

Vue.directive("click-outside", {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function(el: any) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
});

Vue.config.productionTip = false;
Vue.prototype.modals = modals;
Vue.prototype.permissions = permissions;
Vue.prototype.formatMoney = (amount: number, decimalPlaces = 2) =>
  numbro(amount).formatCurrency({ mantissa: decimalPlaces });

Vue.mixin({
  methods: {
    hasPermission(permission, isAgentObject: boolean|null = false) {   
      if(isAgentObject) {
        let agentPermission = "agents." + permission;
        if(permissionExists(agentPermission)) {
          return store.state["account"].permissions.indexOf(agentPermission) > -1;
        }
      }
      return store.state["account"].permissions.indexOf(permission) > -1;
    },
    hasAgentPermission(permission: string, deliveryForId: number|null) {
      if(deliveryForId > 0) {
        return store.state["account"].permissions.indexOf("agents." + permission) > -1;
      } else {
        return store.state["account"].permissions.indexOf(permission) > -1;
      }
    },
    mobile() {
      return isMobile;
    }
  }
});

const vue = new Vue({
  router,
  store,
  render: h => h(App)
});

vue.$mount("#app");

if (
  process.env.NODE_ENV &&
  (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "uat")
) {
  Vue.config.devtools = true;
}
